import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    AfterViewInit, Inject, OnChanges, SimpleChanges, AfterContentInit,OnDestroy
} from '@angular/core';
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {cloneDeep, get} from "lodash";
import {ResolvableComponent} from "@ispm/core/decorators/resolvable-component.decorator";
import * as jsonPath from 'jsonpath';
import {IAggregator} from "@ispm/dynamic-form/interfaces/IAggregator.interface";
import {AggregationFactory} from "@ispm-client/modules/events/components/event-finding-ribbon/aggregation-factory";
import {EventService} from "@ispm-client/modules/events/services/event.service";
import {NLPValidationWizardComponent} from "@ispm-client/modules/events/components/nlp-validation-wizard/nlp-validation-wizard.component";
import {Observable, of, Subscription, Subject} from "rxjs";
import {IEvent} from "@ispm-client/modules/events/Interfaces";
import {map} from "formula";
import {EventValidationWizardService} from "@ispm-client/modules/events/services/event-validation-wizard.service";
import {FormulaAggregatorService} from "@ispm/shared/services/event-formula-filter.service";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
    selector: 'ispm-event-finding-ribbon',
    templateUrl: './event-finding-ribbon.component.html',
    styleUrls: ['./event-finding-ribbon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

@ResolvableComponent()
export class EventFindingRibbonComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy,AfterContentInit, IWidgetItem {
  private componentDestroyer: Subject<any> = new Subject();
  public tableData: any;
    public formItems: any;
    public widgetPayload: any;
    public data;
    public formId: any;
    public eventData: any;
    private aggregationFactory: AggregationFactory = new AggregationFactory();
    public isButton: boolean;
    private buttonLabel: string;
    public actionItems: any;
    private wizard: NLPValidationWizardComponent;
    private reviewExtractionKey: any;
    public disabled:boolean;
    public endPoint: any;
    public actions: any;
    public selectedEvent:any;
    private currentActiveFile:any;
    public dynamicFormData: any;
    private formulaAggregatorService:FormulaAggregatorService=new FormulaAggregatorService();

    constructor(private _changeDetector: ChangeDetectorRef,
                private _eventService: EventService,
                private eventWizardService: EventValidationWizardService,
                private notificationMessageService: NotificationMessageService,
                ) {

      this._eventService.getSelectedEvent().subscribe(data =>{
        this.eventData = data
      })
    }

  ngOnInit() {

  }

    ngAfterViewInit(): void {
      //TODO all these specific keywords need to be removed
        if ((this.eventData['nlpFindings'] !== undefined && this.eventData['nlpFindings'][0]['nlpPositiveFindings'] === 'true') && document.getElementById("#extract")) {
            (<HTMLInputElement>document.getElementById("#extract")).classList.add('check-disable');
        }
        if((this.data['sample'] <= 0) && (document.getElementById("#validate"))){
            (<HTMLInputElement>document.getElementById("#validate")).classList.add('check-disable');
        }
    }
    ngAfterContentInit(): void {
        this._eventService.currentActiveFile.takeUntil(this.componentDestroyer.asObservable()).subscribe(res =>{
            this.currentActiveFile = this.checkCondition();
        });

        this._eventService.isButtonDisable.takeUntil(this.componentDestroyer.asObservable()).subscribe(res =>{
            this.getCurrentVisibleEvent().takeUntil(this.componentDestroyer.asObservable()).subscribe(event =>{
                if (event['nlpFindings'] !== undefined
                    && event['nlpFindings'].length>0) {
                    this._eventService.setIsButtonDisable(true);
                }else{
                    this._eventService.setIsButtonDisable(false);
                }
            });
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedEvent = this.getCurrentVisibleEvent();

        // Change Button Visibility after onCompleteWorkflow via polling
        this._eventService.onCompleteWorkflow.takeUntil(this.componentDestroyer.asObservable()).subscribe(res=>{
            if(this.eventData['nlpFindings'] !== undefined) {
                this.eventData['nlpFindings'].forEach(function (nlpFinding) {
                    if(<HTMLInputElement>document.getElementById("#extract") !== null
                    && (<HTMLInputElement>document.getElementById("#extract")).classList.length>0){
                        if (nlpFinding !== undefined
                            && nlpFinding['nlpPositiveFindings'] === 'true'
                            && nlpFinding['fileReference'] === this.currentActiveFile._subscriptions[0]._subscriptions[1].subject._value.reference) {
                            (<HTMLInputElement>document.getElementById("#extract")).classList.add('check-disable');
                            this._eventService.setIsButtonDisable(true)
                        } else {
                            (<HTMLInputElement>document.getElementById("#extract")).classList.remove('check-disable');
                        }
                    }

                });
            }
        });
        if(this.data['sample'] <= 0){
            (<HTMLInputElement>document.getElementById("#validate")).classList.add('check-disable');
        }
    }

    set widgetConfig(widgetConfig: IdynamicFormItem) {
        this.formId = widgetConfig.widgetPayload.formId;
        this.widgetPayload = widgetConfig.widgetPayload;
        this.isButton = widgetConfig.widgetPayload.showButton;
        this.buttonLabel = widgetConfig.widgetPayload.showButton;
        this.actionItems = widgetConfig.widgetPayload.actions;
        this.reviewExtractionKey = widgetConfig.widgetPayload.reviewExtractionKey;
    }

    set widgetData(widgetData: any) {
        //this.eventData = cloneDeep(widgetData);
        this.dynamicFormData = cloneDeep(widgetData);

        this.getAggregatedData();
        let outputData = this.getFilteredData();

        this.data = outputData;
        this._changeDetector.markForCheck();
        this._changeDetector.detectChanges();

        if (this.eventData['nlpFindings'] !== undefined
            && this.eventData['nlpFindings'].length>0) {
            this._eventService.setIsButtonDisable(true);
        }
    }

    getAggregatedData(){
        let formulaAggr = get(this.widgetPayload, 'formulas');
        //let outputObj: any = {};

        if (Array.isArray(formulaAggr)) {
            this.formulaAggregatorService.executeFormula(this.dynamicFormData, formulaAggr);
        //   formulaAggr.forEach(aggregator => {
        //     let currentformula = aggregator['formula'];
        //     let currentValuetoset = aggregator['valueToSet'];
        //     let currentInterpolate = aggregator['interpolate'];

        //     let formulaData=this.formulaAggregatorService.executeFormula(this.dynamicFormData, currentformula, currentValuetoset, currentInterpolate);

        //     if(outputObj[aggregator['affectedField']] !== undefined){
        //         outputObj[aggregator['affectedField']] = outputObj[aggregator['affectedField']] + Number(formulaData);
        //     } else {
        //         outputObj[aggregator['affectedField']] = Number(formulaData);
        //     }
        //   })
        }
        //return outputObj;
      }

    getFilteredData(): object {
        let dataAggr: Array<IAggregator> = get(this.widgetPayload, 'dataAggregation');
        let outputObj: any = {};
        if (Array.isArray(dataAggr)) {
            dataAggr.forEach(aggregator => {
                let currentFormItem = aggregator['formItemIdentifier']
                let inputExpression = aggregator['inputElement'];
                let inputData: any;
                if (inputExpression && inputExpression.includes('$')) {//mention in LLDD ..json vs normal input
                    inputData = this.evaluateJsonPath(inputExpression);
                    if (aggregator.hasOwnProperty('aggregationFunction')) {

                        let formData = this.aggregationFactory.executeAggregation(inputData, aggregator['aggregationFunction'],
                            aggregator.hasOwnProperty('filterExpression'),
                            aggregator['filterExpression']);
                        outputObj[currentFormItem] = formData;
                    } else {//input element here can also be json path
                        //let formData2 = this.aggregationFactory.getPropertyValue(inputData, aggregator['inputElement']);
                        let formData2 = inputData;
                        outputObj[currentFormItem] = formData2;
                    }
                } else {

                    let formData3 = this.aggregationFactory.getPropertyValue(this.eventData, aggregator['inputElement']);
                    outputObj[currentFormItem] = formData3;
                }
            })
            return outputObj;
        }
    }

    launchNLPValidate() {
        this._eventService.setViewWizard(true);
        this.eventWizardService.setReviewExtractionKey(this.reviewExtractionKey);
    }

    performAction(action: any) {
        this.actions = action;
        switch (this.actions.type) {
            case "validate":
                this.launchNLPValidate();
                break;
            case "extract":
                //Only extract type Trigger NLP
                this.notifyToExtractWorkflow(this.actions.backendEndpoint);
                break;
        }
    }

    private evaluateJsonPath(inputData: any): any {
        let response;
        if(this.dynamicFormData instanceof Object ){
            response = jsonPath.query(this.dynamicFormData, inputData);
        }else{
            response = jsonPath.query(this.eventData, inputData);
        }
        return response;
    }

    public isNoFinding() {
        (<HTMLInputElement>document.getElementById("#validate")).classList.remove('check-disable');
        if(this.data['sample'] <= 0){
            (<HTMLInputElement>document.getElementById("#validate")).classList.add('check-disable');
         }
    }

    private notifyToExtractWorkflow(action: any) {
        // Start - Rearrange logic/array
        /** Put selected file at '0'th index bcz NLP template usage [0] index file to avoid duplication in template
        for extraction rearrange the file index
        After extraction or last triggered :
            First file will be selected one
         **/
        let currentActiveFileObj =  [{
                name: this.currentActiveFile._subscriptions[0]._subscriptions[1].subject._value.name,
                reference: this.currentActiveFile._subscriptions[0]._subscriptions[1].subject._value.reference,
                contentType:"file",
                resourceType:this.currentActiveFile._subscriptions[0]._subscriptions[1].subject._value.resourceType
            }];
        let requestBody = Object.assign(this.eventData, this.actions.updatePayload);
        this.endPoint = this.actions.backendEndpoint;
           let fileName =  currentActiveFileObj[0]['name'];
           //Checking file exist in event ?
           if(fileName !== undefined){
               //Checking file type txt ?
                if(fileName.substring(fileName.length,fileName.length-3) === 'txt'){
                   let copyContent = requestBody['content'];
                   // Copying rest other file except selected file into new array from 1'th to n'th
                    for(let index =0; index<copyContent.length; index++){
                        if(copyContent[index]['reference'] != currentActiveFileObj[0]['reference']){
                            currentActiveFileObj.push(copyContent[index]);
                        }
                    }
                    // End - Rearrange logic/array
                    requestBody['content'] = currentActiveFileObj;
                    //before trigger disable button
                    (<HTMLInputElement>document.getElementById("#extract")).classList.add('check-disable');
                    this._eventService.setIsButtonDisable(true);
                    this._eventService.notifyExtractWorkflow(this.eventData.id, requestBody, this.endPoint).subscribe(
                        res => {
                            //after trigger disable button
                            (<HTMLInputElement>document.getElementById("#extract")).classList.add('check-disable');
                            this._eventService.setIsButtonDisable(true);
                        },error=>{
                            this.notificationMessageService.error("Extraction Failed: "+error)
                            return Observable.throw(error);
                        },() => {
                        }
                    )
                }else {
                    this.notificationMessageService.error("Only TXT file allowed to extract!!!");
                }
            }else{
                this.notificationMessageService.error("No file exist!!!");
            }

    }
    ;
    private checkCondition():Subscription {
        let mapExtractedFile:Map<any, any> = new Map();
        // Change Button Visibility for selected file
        return this._eventService.currentActiveFile.takeUntil(this.componentDestroyer.asObservable()).subscribe( currentActiveFile => {
          this.getCurrentVisibleEvent().takeUntil(this.componentDestroyer.asObservable()).filter(currentActiveEvent => currentActiveEvent !== null).subscribe(currentActiveEvent => {
                // check nlpFindings array exist if exist then loop all object and check previously triggered or not for selected file
                // If YES - disable
                if(currentActiveEvent['nlpFindings'] !== undefined) {
                    mapExtractedFile = currentActiveEvent['nlpFindings'].reduce(function(map, obj){
                        if(obj.nlpPositiveFindings == 'true'){
                            mapExtractedFile.set(obj.fileReference,obj.nlpPositiveFindings);
                        }
                        return mapExtractedFile;
                    }, {});
                    if(<HTMLInputElement>document.getElementById("#extract") !== null
                        && (<HTMLInputElement>document.getElementById("#extract")).classList.length>0){
                        if(mapExtractedFile.has(currentActiveFile['reference'])){
                            (<HTMLInputElement>document.getElementById("#extract")).classList.add('check-disable');

                        }else {
                            (<HTMLInputElement>document.getElementById("#extract")).classList.remove('check-disable');
                        }
                    }
                }
                return of({
                    name: currentActiveFile['name'],
                    reference: currentActiveFile['reference'],
                    contentType: currentActiveFile['contentType'],
                    resourceType: currentActiveFile['resourceType']
                })
            });

        });
    }

    private getCurrentVisibleEvent():Observable<any>{
        return this._eventService.getSelectedEvent();
    }

  ngOnDestroy(): void {
    this.componentDestroyer.next();
    this.componentDestroyer.complete();
    this._changeDetector.detach();
  }
}
